module.exports = {
  REACT_APP_NAME: "Myセブン銀行管理システム"
};
